/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-07-22 16:07:07
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-08-01 14:10:31
 * @FilePath: \crm-product\found\views\mdm\views\adjustment_supply\form\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Form, {
  formCreate,
} from '../../../../../components/form';
import request from '../../../../../utils/request';
import Custom from './custom.vue';
import CustomMore from './custom_more.vue';
import detaillVos from './supplys.vue';

formCreate.component('Custom', Custom);
formCreate.component('CustomMore', CustomMore);
formCreate.component('detaillVos', detaillVos);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formParentCode: 'CRM20260722000000002',
      formFunctionCode: 'main-form',
      buttonText: {
        submit: '暂存',
        close: '关闭',
        submitAudit: '提交',
      },
      buttons: {
        submit: true,
        close: true,
        submitAudit: true,
      },
    };
  },
  async created() {
    // await this.getFormRule('main-form');
  },
  methods: {
    setRule(item) {
      const v = item;
      v.props = {
        ...v.props,
        getRule: this.getRule,
        field: item.field,
      };
      if (item.field === 'type') {
        item.on = {
          ...item.on,
          change: (val) => {
            const afterDealerName = this.getRule('afterDealerName');
            const afterSalesmanName = this.getRule('afterSalesmanName');
            const afterProductName = this.getRule('afterProductName');
            const detaill = this.getRule('detaillVos');
            const h1 = this.getRule('h1');
            const h2 = this.getRule('h2');
            const h3 = this.getRule('h3');
            const customerList = this.getRule('customerList');
            const salesmanList = this.getRule('salesmanList');
            const productList = this.getRule('productList');
            detaill.props = {
              ...detaill.props,
              type: val,
            };
            if (val === 'add') {
              afterDealerName.validate[0].required = true;
              afterSalesmanName.validate[0].required = true;
              afterProductName.validate[0].required = true;

              h1.props.title = '新增前条件筛选（用于圈定新增范围）';
              h2.props.title = '选择终端';
              h3.props.title = '新增供货关系信息（将为所选终端新增供货关系）';
              customerList.title = '经销商';
              salesmanList.title = '业务员';
              productList.title = '产品';
              afterDealerName.title = '经销商';
              afterSalesmanName.title = '业务员';
              afterProductName.title = '产品';
            } else {
              afterDealerName.validate[0].required = false;
              afterSalesmanName.validate[0].required = false;
              afterProductName.validate[0].required = false;

              h1.props.title = '变更前条件筛选（至少填写一项，用于筛选待选供货关系）';
              h2.props.title = '选择供货关系';
              h3.props.title = '变更后目标值设置（未填写的项保持原值不变）';
              customerList.title = '变更前经销商';
              salesmanList.title = '变更前业务员';
              productList.title = '变更前产品';
              afterDealerName.title = '变更后经销商';
              afterSalesmanName.title = '变更后业务员';
              afterProductName.title = '变更后产品';
            }
          },
        };
      }

      // 组织
      if (item.field === 'orgList') {
        item.props = {
          ...item.props,
          params: {
            functionCode: 'org_list',
            idKey: 'code',
          },
          title: item.title,
        };
        item.on = {
          ...item.on,
          change: (e) => {
            if (e) {
              this.setValue({
                orgList: e,
              });
            }
          },
        };
      }

      // 经销商
      if (item.field === 'customerList') {
        item.props = {
          ...item.props,
          params: {
            functionCode: 'customer_after_list',
          },
          title: item.title,
        };
        item.on = {
          ...item.on,
          change: (e) => {
            if (e) {
              console.log(e);
              this.setValue({
                customerList: e,
                seriesList: [],
                productList: [],
              });
            }
          },
        };
      }

      // 业务员
      if (item.field === 'salesmanList') {
        item.props = {
          ...item.props,
          params: {
            functionCode: 'salesman_list',
            idKey: 'code',
          },
          title: item.title,
        };
        item.on = {
          ...item.on,
          change: (e) => {
            if (e) {
              this.setValue({
                salesmanList: e,
              });
            }
          },
        };
      }

      // 系列
      if (item.field === 'seriesList') {
        item.props = {
          ...item.props,
          params: {
            functionCode: 'series_list',
            idKey: 'code',
          },
          title: item.title,
        };
        item.on = {
          ...item.on,
          change: (e) => {
            if (e) {
              this.setValue({
                seriesList: e,
                productList: [],
              });
            }
          },
        };
      }

      // 产品
      if (item.field === 'productList') {
        item.props = {
          ...item.props,
          params: {
            functionCode: 'product_list',
            idKey: 'code',
          },
          title: item.title,
        };
        item.on = {
          ...item.on,
          change: (e) => {
            if (e) {
              this.setValue({
                productList: e,
              });
            }
          },
        };
      }

      // 变更后经销商
      if (item.field === 'afterDealerName') {
        item.props = {
          ...item.props,
          params: {
            functionCode: 'customer_after_list',
          },
          title: item.title,
        };
        item.on = {
          ...item.on,
          change: (e) => {
            if (e) {
              this.setValue({
                afterDealerName: e[0].name,
                afterDealerCode: e[0].code,
              });
            } else {
              this.setValue({
                afterDealerName: '',
                afterDealerCode: '',
              });
            }
          },
        };
      }

      // 变更后业务员
      if (item.field === 'afterSalesmanName') {
        item.props = {
          ...item.props,
          params: {
            functionCode: 'salesman_after_list',
          },
          title: item.title,
        };
        item.on = {
          ...item.on,
          change: (e) => {
            if (e) {
              this.setValue({
                afterSalesmanName: e[0].userName,
                afterSalesmanCode: e[0].userCode,
                afterSalesmanPosCode: e[0].code,
                afterSalesmanPosName: e[0].name,
              });
            } else {
              this.setValue({
                afterSalesmanName: '',
                afterSalesmanCode: '',
                afterSalesmanPosCode: '',
                afterSalesmanPosName: '',
              });
            }
          },
        };
      }

      // 变更后产品
      if (item.field === 'afterProductName') {
        item.props = {
          ...item.props,
          params: {
            functionCode: 'product_after_list',
          },
          title: item.title,
        };
        item.on = {
          ...item.on,
          change: (e) => {
            if (e) {
              this.setValue({
                afterProductName: e[0].productName,
                afterProductCode: e[0].productCode,
                afterProductSeriesCode: e[0].productLevelCode,
                afterProductSeriesName: e[0].productLevelName,
              });
            } else {
              this.setValue({
                afterProductName: '',
                afterProductCode: '',
                afterProductSeriesCode: '',
                afterProductSeriesName: '',
              });
            }
          },
        };
      }

      // 附件
      if (item.field === 'attach') {
        item.props = {
          ...item.props,
          fileMsg: '只能上传pdf/word/excel/ppt/png/jpg文件',
          accept: '.pdf,.doc,.docx,.xlsx,.xls,.ppt,.pptx,.png,.jpg',
        };
      }
      return v;
    },
    /**
     * 表单渲染完成后回调
     */
    formComplete() {
      if (this.formConfig.row && this.formConfig.row.id) {
        const params = {
          id: this.formConfig.row.id,
        };
        request.post('/mdm/mdmsupplyadjustapply/query', params)
          .then((res) => {
            if (res.success) {
              const detaill = this.getRule('detaillVos');
              detaill.props = {
                ...detaill.props,
                type: res.result.type,
              };
              const afterDealerName = this.getRule('afterDealerName');
              const afterSalesmanName = this.getRule('afterSalesmanName');
              const afterProductName = this.getRule('afterProductName');
              const h1 = this.getRule('h1');
              const h2 = this.getRule('h2');
              const h3 = this.getRule('h3');
              const customerList = this.getRule('customerList');
              const salesmanList = this.getRule('salesmanList');
              const productList = this.getRule('productList');
              if (res.result.type === 'add') {
                afterDealerName.validate[0].required = true;
                afterSalesmanName.validate[0].required = true;
                afterProductName.validate[0].required = true;

                h1.props.title = '新增前条件筛选（用于圈定新增范围）';
                h2.props.title = '选择终端';
                h3.props.title = '新增供货关系信息（将为所选终端新增供货关系）';
                customerList.title = '经销商';
                salesmanList.title = '业务员';
                productList.title = '产品';
                afterDealerName.title = '经销商';
                afterSalesmanName.title = '业务员';
                afterProductName.title = '产品';
              }
              this.setValue({
                ...res.result,
                seriesList: res.result.queryVo?.seriesList || [] || [],
                productList: res.result.queryVo?.productList || [] || [],
                customerList: res.result.queryVo?.customerList || [] || [],
                salesmanList: res.result.queryVo?.salesmanList || [] || [],
                orgList: res.result.queryVo?.orgList || [] || [],
              });
            }
          });
      } else {
        this.setValue({
          type: 'update',
        });
        const detaill = this.getRule('detaillVos');
        detaill.props = {
          ...detaill.props,
          type: 'update',
        };
      }
    },
    // 提交
    submit(index) {
      const formData = this.getFormData();
      if (formData) {
        let url = '/mdm/mdmsupplyadjustapply/save';
        const params = formData;
        params.queryVo = {
          orgList: params.orgList || [],
          customerList: params.customerList || [],
          salesmanList: params.salesmanList || [],
          productList: params.productList || [],
          seriesList: params.seriesList || [],
        };
        if (this.formConfig && this.formConfig.code === 'edit') {
          params.id = this.formConfig.row.id;
          params.code = this.formConfig.row.code;
          url = '/mdm/mdmsupplyadjustapply/update';
        }

        if (!params.detaillVos || params.detaillVos.length === 0) {
          this.$message({
            type: 'error',
            message: params.type === 'update' ? '请选择供货关系' : '请选择终端',
          });
          return;
        }

        if (params.type === 'update' && !params.afterDealerName && !params.afterSalesmanName && !params.afterProductName) {
          this.$message({
            type: 'error',
            message: '变更时，变更后经销商、业务员、产品不能都为空',
          });
          return;
        }
        params.submitType = index;
        if (index === 1) {
          request.post(url, params).then((res) => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '操作成功',
              });
              this.$emit('onClose');
              this.$emit('onGetList');
            }
          });
        } else {
          this.$emit('submit', {
            row: {
              ...params,
            },
            submitUrl: url,
          });
        }
      }
    },
  },
};
